import React, { useState } from 'react'
import { connect } from 'react-redux'
import { useFirebase } from 'react-redux-firebase'
import Modal from 'src/components/UI/Modal/Modal'
import Confirm from 'src/components/UI/Confirm/Confirm'
import confirmClasses from 'src/components/UI/Confirm/Confirm.module.scss'
import textConstants from 'training-lane-booking-shared/utilities/text'

const PaymentProcessorModal = ({
    cart,
    purgeCart,
    updatePaymentRequest,
    setModalState,
    log
}) => {
    const [confirmed, setConfirmed] = useState(false)

    const firebase = useFirebase()

    const handleConfirm = async () => {
        await updatePaymentRequest(cart, firebase)
            .then(({ data }) => {
                if (data.error) {
                    setModalState('confirm', {
                        state: true,
                        props: {
                            heading: textConstants.ERROR_TECHNICAL,
                            single: true
                        }
                    })
                } else {
                    purgeCart()
                    setConfirmed(true)
                }
            })
            .catch(error => {
                log({ message: 'Error in PaymentProcessorModal - handleConfirm:', error, firebase })
            })
    }

    return (
        <Modal
            name="paymentProcessor"
            nested
            handleClose={() => setConfirmed(false)}>
            <Confirm
                newLineAboveButtons={false}
                heading={
                    confirmed ? (
                        <div>{textConstants.PRI_RECEIVED}</div>
                    ) : (
                        <div>{textConstants.PURCHASE_CONFIRM_HEADING}</div>
                    )
                }
                smallPrint={
                    confirmed ? (
                        <div>{textConstants.PRI_THANK_YOU}</div>
                    ) : (
                        <div>{textConstants.PURCHASE_CONFIRM_BODY}</div>
                    )
                }
                buttons={[
                    confirmed
                        ? {
                              buttonClasses:
                                  confirmClasses.confirmButtonProceedSafe,
                              handleFn: () =>
                                  setModalState('paymentProcessor', {
                                      state: false
                                  }),
                              label: textConstants.DISMISS
                          }
                        : {
                              buttonClasses:
                                  confirmClasses.confirmButtonProceedDanger,
                              handleFn: handleConfirm,
                              label: textConstants.PROCEED
                          }
                ]}
            />
        </Modal>
    )
}

const mapDispatch = dispatch => ({
    purgeCart: () => dispatch.cart.purgeCart(),
    updatePaymentRequest: (cart, firebase) =>
        dispatch.payments.updatePaymentRequest({ cart, firebase }),
    setModalState: (modalName, payload) =>
        dispatch.utils.setModalState(modalName, payload),
    log: payload => dispatch.utils.log(payload)
})

export default connect(null, mapDispatch)(PaymentProcessorModal)
